import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EnvironmentService } from '@core/feature';
import { ProductCardNavigationService } from '@product/feature';
import { CMSTabParagraphContainer } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { combineLatest } from 'rxjs';
import { delay, filter, take } from 'rxjs/operators';

/**
 * Регистрирует компонент в компоненте с табами sd-custom-tab-paragraph-container.
 * Если отрисовался компонент с директивой - то отрисуется и таб навигации.
 */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[sdProductCardNavigation]',
  standalone: false,
})
export class ProductCardNavigationDirective implements OnInit, OnDestroy {
  constructor(
    private el: ElementRef,
    private componentData: CmsComponentData<CMSTabParagraphContainer>,
    private route: ActivatedRoute,
    private productCardNavigationService: ProductCardNavigationService,
    private environmentService: EnvironmentService,
  ) {
    this.el.nativeElement.id = this.componentData.uid;
  }

  ngOnInit(): void {
    this.productCardNavigationService.addToVisibleTabs(this.componentData.uid);

    // Обязательно выполнять в браузере, так как delay затомарживает вывод страницы на SSR
    if (this.environmentService.isPlatformBrowser) {
      combineLatest([this.route.fragment, this.productCardNavigationService.getActiveTab()])
        .pipe(
          take(1),
          filter(([fragment, activeTab]) => Boolean(fragment && !activeTab && fragment === this.componentData.uid)),
          delay(1000),
        )
        .subscribe(([fragment]) => {
          this.productCardNavigationService.setActiveTab(fragment);
        });
    }
  }

  ngOnDestroy(): void {
    this.productCardNavigationService.removeFromVisibleTabs(this.componentData.uid);
  }
}
